import type { AssessmentResultsListItem } from '../model/types/assessment-results/interfaces'
import type { ScopeMode } from '@shared/lib/scope'

import { useCsRoutes } from '@shared/api'

import { useAssessmentResultsStore } from '../model/assessment-results-store'

interface AssessmentResultsListApiReturn {
  fetchAssessmentResults: (disciplineId: number, mode: ScopeMode) => Promise<void>
}

export const useAssessmentResultsListApi = (): AssessmentResultsListApiReturn => {
  const { $axios } = useNuxtApp()
  const assessmentResultsStore = useAssessmentResultsStore()

  const requestList = async (url: string): Promise<AssessmentResultsListItem[]> => {
    const { data } = await $axios.get(url)

    return (data?.data ?? []) as AssessmentResultsListItem[]
  }

  const fetchAssessmentResults = async (disciplineId: number, mode: ScopeMode): Promise<void> => {
    const url = useCsRoutes('disciplines.assessment-results', {
      '[discipline_id]': disciplineId,
    })

    if (!url) {
      console.warn('missing url for assessment-results/list.hook.ts')

      return
    }

    const requestId = assessmentResultsStore.beginList(disciplineId, mode)

    try {
      assessmentResultsStore.settleList(disciplineId, requestId, await requestList(url))
    } catch (err: unknown) {
      console.error('unable to retrieve assessment-results/list.hook.ts:', err)

      assessmentResultsStore.failList(disciplineId, requestId)
    }
  }

  return { fetchAssessmentResults }
}
